@if (initialized && dto) {
    @if (uiMode == 'side') {

        <bm-customer-billing-transaction-type-side
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)"
        ></bm-customer-billing-transaction-type-side>
    } @else {

        <bm-customer-billing-transaction-type-full
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)"
        ></bm-customer-billing-transaction-type-full>
    }
}
